import styled from "styled-components";

export const StyledContainer = styled("div")<{
  border?: boolean;
}>`
  position: relative;
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding: 0;


`;
